<template>
  <v-btn icon @click="onClick">
    <v-icon
      :color="
        loading
          ? 'grey lighten-3'
          : localActive
          ? 'yellow darken-2'
          : 'grey lighten-1'
      "
    >
      fa-star
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    menuId: {
      type: String,
      required: true
    },

    active: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      localActive: false
    }
  },

  watch: {
    active() {
      this.mapAction()
    }
  },

  mounted() {
    this.mapAction()
  },

  methods: {
    mapAction() {
      this.localActive = this.active
    },

    async onClick() {
      const body = [
        {
          ProgramItemMenuID: this.menuId,
          EnableStatus: !this.localActive,
          SortOrder: ''
        }
      ]

      await this.$store.dispatch('dashboard/updateFavoriteList', body)

      this.mapAction()
      this.$emit('update')
    }
  }
}
</script>

<style lang="scss" scoped></style>
